
/////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////
//                                                         //
//                   JS FOR PICTURE LIBRARY                //
//                                                         //
/////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////

window.openPictureLibraryMarketing = function openPictureLibraryMarketing(){
  $('.sidepanel--scrim').fadeIn();
  $('.a__body').addClass('u-overflow-y-hidden');
  $('.picture-marketing-library').removeClass('u-display-none');
};

window.closePictureLibraryMarketing = function closePictureLibraryMarketing(){
  $('.sidepanel--scrim').fadeOut();
  $('.a__body').removeClass('u-overflow-y-hidden');
  $('.picture-marketing-library').addClass('u-display-none');
};

window.openPictureLibraryClient = function openPictureLibraryClient(){
  $('.sidepanel--scrim').fadeIn();
  $('.a__body').addClass('u-overflow-y-hidden');
  $('.picture-client-library').removeClass('u-display-none');
};

window.closePictureLibraryClient = function closePictureLibraryClient(){
  $('.sidepanel--scrim').fadeOut();
  $('.a__body').removeClass('u-overflow-y-hidden');
  $('.picture-client-library').addClass('u-display-none');
};
